import {
  UserRefundProgramListModel,
  UserRefundProgramModel
} from '@/domain/models/refund/user-refund-program-list-model'

export interface UserRefundProgramList {
  get(): Promise<UserRefundProgramList.Model>
}

export namespace UserRefundProgramList {
  export type Model = UserRefundProgramListModel
  export type ItemModel = UserRefundProgramModel
  export const Key = 'refund-program-list'
}
